import React from 'react';
import { Button } from '../../ui/button';

const ConfirmModal = ({ isOpen, onClose, onConfirm, title, message }) => {
  if (!isOpen) return null;

  return (
    <div className={`fixed inset-0 flex items-center justify-center z-50 modal-overlay ${isOpen ? '' : 'hidden'}`}>
      <div className="p-6 bg-white rounded-lg shadow-md w-full md:w-[400px]">
        <h3 className="text-lg font-semibold mb-4">{title || 'Confirm Action'}</h3>
        <p className="text-sm text-gray-600 mb-6">{message || 'Are you sure you want to proceed?'}</p>
        <div className="flex justify-end gap-3">
          <Button variant="outline" onClick={onClose}>
            Cancel
          </Button>
          <Button variant="destructive" onClick={onConfirm}> {/* Or default/primary based on context */}
            Confirm
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmModal; 